import { object, string } from 'superstruct';
import { password } from '@arc/shared/util-superstruct';
export const ResetPasswordDto = object({
  token: string(),
  newPassword: password()
});